<div class="strategy-card">
    <div class="strategy-card__head">
        <span class="strategy-card__title" [attr.title]="data() | translateToken: 'name'">{{ data() | translateToken: "name" }}</span>

        <span class="strategy-card__logo">
            @if (logo(); as source) {
                <img [src]="source" [attr.alt]="data() | translateToken: 'name'" />
            } @else {
                <span class="strategy-card__initials">{{ initials() }}</span>
            }
        </span>
    </div>

    <div class="strategy-card__stats">
        @for (metric of metrics(); track metric.label) {
            <div class="strategy-card__metric">
                <div class="strategy-card__metric-head">
                    <span class="strategy-card__metric-label">{{ metric.label | translate }}</span>

                    <span class="strategy-card__metric-value" [style.color]="metric.color">
                        @if (metric.progress > 0) {
                            <adaa-count-up [total]="metric.value!" [fontSize]="valueFontSize" />
                        } @else {
                            {{ metric.value | percentageValue }}
                        }
                    </span>
                </div>

                <span
                    class="strategy-card__bar"
                    role="progressbar"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    [attr.aria-valuenow]="metric.progress"
                    [attr.aria-label]="metric.label | translate"
                >
                    <span [style.width.%]="metric.progress" [style.background-color]="metric.color"></span>
                </span>
            </div>
        }
    </div>
</div>
